"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const get = require("lodash.get");
let LANG_PACK = {};
let LANG_PACK_NEED = {};
function setLangPack(langPack) {
    LANG_PACK_NEED = {};
    LANG_PACK = Object.assign(LANG_PACK, langPack);
}
exports.setLangPack = setLangPack;
function getLangPageNeed() {
    return LANG_PACK_NEED;
}
exports.getLangPageNeed = getLangPageNeed;
function lang(key, defaultVal) {
    const val = get(LANG_PACK, key, defaultVal || key);
    LANG_PACK_NEED[key] = val;
    return val;
}
exports.lang = lang;
exports.__ = lang;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFuZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxhbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxrQ0FBa0M7QUFFbEMsSUFBSSxTQUFTLEdBQUcsRUFBRSxDQUFDO0FBQ25CLElBQUksY0FBYyxHQUFHLEVBQUUsQ0FBQztBQUV4QixTQUFnQixXQUFXLENBQUMsUUFBUTtJQUNoQyxjQUFjLEdBQUcsRUFBRSxDQUFDO0lBQ3BCLFNBQVMsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQztBQUNuRCxDQUFDO0FBSEQsa0NBR0M7QUFFRCxTQUFnQixlQUFlO0lBQzNCLE9BQU8sY0FBYyxDQUFDO0FBQzFCLENBQUM7QUFGRCwwQ0FFQztBQUVELFNBQWdCLElBQUksQ0FBQyxHQUFXLEVBQUUsVUFBbUI7SUFDakQsTUFBTSxHQUFHLEdBQUcsR0FBRyxDQUFDLFNBQVMsRUFBRSxHQUFHLEVBQUUsVUFBVSxJQUFJLEdBQUcsQ0FBQyxDQUFDO0lBQ25ELGNBQWMsQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUM7SUFDMUIsT0FBTyxHQUFHLENBQUM7QUFDZixDQUFDO0FBSkQsb0JBSUM7QUFFWSxRQUFBLEVBQUUsR0FBRyxJQUFJLENBQUMifQ==